<div class="mat-elevation-z1 fliko-table" [class.newStyle]="_config.newStyle" [class.multiRows]="_config.multiTemplateDataRows">
  <ng-container *ngIf="dataSource">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      class="table-width full-width full-height"
      [multiTemplateDataRows]="_config.multiTemplateDataRows"
    >
      <ng-container *ngFor="let column of dataColumns">
        <ng-container [matColumnDef]="column.value">
          <!-- HEADER -->
          <ng-container *matHeaderCellDef>
            <th
              mat-header-cell
              [mat-sort-header]="column.sort ? column.value : ''"
              [disabled]="!column.sort"
              [ngStyle]="{ width: column.width + 'px' }"
            >
              <ng-container *ngIf="!headerRef">
                <mat-icon *ngIf="column.icon; else colName" [matTooltip]="column.name | locLabel">{{ column.icon }}</mat-icon>
                <ng-template #colName>
                  <ng-container *ngTemplateOutlet="templateService.defaultRowTableHeader; context: { column: column }">
                  </ng-container>
                </ng-template>
              </ng-container>
              <ng-container *ngIf="headerRef">
                <ng-container *ngTemplateOutlet="headerRef; context: { column: column }"></ng-container>
              </ng-container>
            </th>
          </ng-container>
          <!-- CELL -->
          <ng-container *matCellDef="let element">
            <ng-container *ngIf="!templateRef">
              <ng-container *ngIf="element[column.value] as cell">
                <td class="{{ cell.className }}" mat-cell [ngStyle]="{ width: column.width + 'px' }">
                  <ng-container *ngTemplateOutlet="templateService.defaultRowTable; context: { cell: cell }"></ng-container>
                </td>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="templateRef">
              <ng-container *ngTemplateOutlet="templateRef; context: { element: element, column: column }"></ng-container>
            </ng-container>
          </ng-container>
          <!-- END -->
        </ng-container>
      </ng-container>
      <ng-container *ngIf="_config.multiTemplateDataRows && columnRef">
        <ng-container matColumnDef="customColumns">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <ng-container *ngTemplateOutlet="columnRef; context: { element: element }"></ng-container>
          </td>
        </ng-container>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; let i = index; columns: displayedColumns"
        (click)="handleClickOnRow(row, i)"
        [class.clicked]="_config.onClickHighlight && row.id.value == selectedRowId"
      ></tr>
      <ng-container *ngIf="_config.multiTemplateDataRows && columnRef">
        <tr mat-row *matRowDef="let row; columns: ['customColumns']" class="custom-row"></tr>
      </ng-container>
    </table>
    <app-loader *ngIf="!loaded"> </app-loader>

    <mat-paginator
      *ngIf="_config.paginator"
      [pageSizeOptions]="[50, 100, 150]"
      showFirstLastButtons
      (page)="onPageChange($event)"
    ></mat-paginator>
  </ng-container>
</div>
